import { useMap } from 'react-map-gl';
import { useTranslation } from 'react-i18next';
import { useAuthState } from 'state/useAuthState';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';
import { useSelectSingletonPoi } from 'features/mapping/hooks/useSelectSingletonPoi';
import { useMeasureDistanceToolState } from '../../state/useMeasureDistanceToolState';

export const useMapDistanceToolCommandPaletteAction = (): void => {
  const { isToolActive, activateTool } = useMeasureDistanceToolState();
  const selectSingletonPoi = useSelectSingletonPoi();
  const { showMembershipProFeatures } = useAuthState();
  const mapRef = useMap().current;
  const { t } = useTranslation();

  const handleKeyboardShortcut = (): void => {
    const center = mapRef?.getCenter();

    if (!center || !mapRef) {
      return;
    }

    activateTool({ lat: center.lat, lng: center.lng }, mapRef);

    selectSingletonPoi({
      type: 'measureTool',
      metadata: null,
    });
  };

  useKeyboardShortcuts(
    showMembershipProFeatures
      ? [
          {
            category: 'mapTools',
            description: t('keyboardShortcuts.mapTools.measureDistance'),
            keys: 't m',
            handler: handleKeyboardShortcut,
          },
        ]
      : [],
    [isToolActive, showMembershipProFeatures, mapRef],
  );
};
